import React, { useEffect, useState } from "react";
import { Typography, Box, Button, DialogTitle } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import "./unavailablePopup.module.scss";
import UnavailableEventPopup from "./unavailableEventPopup";
import theme from "@genesis/ui-kit/dist/themes/macys";


const UnavailablePopup = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);
    const customQuery ='@media (max-width: 768px)';

    console.log("data----", props.data.eventdata)

    useEffect(() => {
        
        /*if (IsTokenValid(colleagueTKN)) {
            let homeUrl = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_UI_BASE_URL
            window.location.replace(`${homeUrl}login`)
          } */ // isTokenValid
        dialog.show();

    }, []);

 

    const saveUnavailable = () => {
        // call delete and insert api

        /*let data = {
            eventId: props.data.eventdata.eventId,
            ascNbr: props.data.eventdata.ascNbr,
            evtDate: props.data.eventdata.dayDate,
        } */

        //console.log("aa",data)

        let insertData = {
            eventId: props.data.eventdata.eventId,
            ascNbr: props.data.eventdata.ascNbr,
            evtDate: props.data.eventdata.dayDate,
            available: 'n',
            availStartDtm1: '',
            availEndDtm1: '',
            availStartDtm2: '',
            availEndDtm2: '',
            lastUpdatedBy: props.data.eventdata.ascNbr,
            impersonatedBy: personDetails.impersonate_admin_id,
            languageCode: languageDetails.selected !== '' ? languageDetails.selected : 'en'
        }

        let divUrl = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ADD_BY_EVENT_ID_ASC_NBR_EVENT_DATE}`;
        if (props.data.eventdata.responseId !== null ) {
            // divurl for update
            divUrl = `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_BY_EVENT_ID_ASC_NBR_EVENT_DATE}`;
        }
        //TODO: uncomment below line to run local and comment above line  
        //let divUrl = `${environmentVariables.avlApiUrl}${constants.WFM_DELETE_BY_ASC_NBR_EVENT_DATE_EVENT_ID}`  

        if (props.data.eventdata.responseId !== null) {
            // call update call with put request
            axiosInstance.put(divUrl,
                insertData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + colleagueTKN,
                    }
                }).then((response) => {
                    // success close popup
                    props.popupClose();
                    props.popupSave("success");

                })
                .catch((error) => {
                    //catch
                    props.popupClose();
                    props.popupSave("error");
                });
        } else {
            // insert new record
            axiosInstance.post(divUrl,
                insertData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + colleagueTKN,
                    }
                }).then((response) => {
                    //TODO: uncomment below line to run local and comment above line
                    
                    // success close popup
                    props.popupClose();
                    props.popupSave("success");

                })
                .catch((error) => {
                    //catch
                    props.popupClose();
                    props.popupSave("error");
                });
        }


        

    }


    return (
        <Box className="dialog">
            <Dialog className="dialog"
                    sx={{
                        [customQuery]:{

                                '&. MuiDialogContent-root':{overflow:'unset'},

                                '& .MuiDialogTitle-root':{
                                    padding: "0px 0px 6px"
                                },
                                '& .MuiDialog-paper':{
                                    margin:"30px",
                                    scale:2,
                                    height:"45%",
                                    minWidth:"100%"
                                }, 
                                ' .MuiDialogActions-root' : {
                                    padding: "0px 0px 0% 0px"
                                }
                        }
                }}
                open={dialog.open}
                title={props.title}
                onClose={props.popupClose}
                actions={
                    <>

                        <Button onClick={props.popupClose}>Cancel</Button>
                        <Button color="secondary" onClick={saveUnavailable}>Save</Button>
                    </>
                }
            >
                <DialogTitle className="title"></DialogTitle>
                <Typography>{props.message}</Typography>
            </Dialog>
        </Box>
    );
}

export default UnavailablePopup;

